import { CoreGlobalNavigationFooterData } from 'src/types/components';

import Link from 'components/BaseHelpers/Link';

import styles from './ComplianceNav.module.scss';

export type ComplianceNavProps = {
  navigationItems: CoreGlobalNavigationFooterData['fields']['complianceLinks'];
};

const ComplianceNav = ({ navigationItems }: ComplianceNavProps) => {
  if (navigationItems.length === 0) return null;

  return (
    <nav className={styles.nav}>
      <ul className={styles.list}>
        {navigationItems.map(({ label, href, target }, index) => {
          return (
            <li className={styles.item} key={`footer-other-nav-${index}`}>
              <Link href={href} target={target} className={styles.link}>
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default ComplianceNav;
